<!--UploadFile-->
<template>
	<div class="question-container" style="border: 1px solid #edeff2">
		<div class="question-type">上传文件</div>
		<div class="title-view" :style="{ marginRight: '' }">
			<!-- <p style="color: #4c4a56">
				<span v-if="dataObj.isMust === 1" class="asterisk">*</span>
				{{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
				<span style="color: #4c4a56">
					{{ dataObj.caseProblem }}
					<span v-if="dataObj.pictureNum" class="pictureNum">
						（仅限上传{{ dataObj.pictureNum }}个文件）
					</span>
				</span>
			</p> -->
			<p class="question-row">
				<span v-if="dataObj.isMust === 1" class="asterisk">*</span>
				<span class="index">{{
				`${dataObj.questionIndex || index + 1}、`
				}}</span>

				<!-- 富文本 + 后缀文字 放在同一个容器里 -->
				<span class="rich-text-wrapper">
					<span class="rich-text-content" v-html="dataObj.caseProblem"></span>
				</span>
			</p>
		</div>

		<div class="question-images">
			<div v-for="(item, index) in images" :key="index" style="margin-top: 10px; position: relative">
				<img :src="item" mode="widthFix" style="width: 100%" />
			</div>
		</div>

		<div class="upload-file">
			<div class="button" @click="chooseFile">
				<img class="icon" src="https://ossfastmake.mustke.com/qrCode/tupian/1761100444730.svg" />
				上传文件
			</div>
			<div class="text">支持word、excel、ppt、pdf格式上传</div>

			<div v-if="fileList.length > 0" class="file-list">
				<div v-for="(item, idx) in fileList" :key="idx" class="file-item">
					<div class="east">
						<img class="icon" src="https://ossfastmake.mustke.com/qrCode/tupian/1762401082820.svg"></img>
						<span>{{ item.name }}</span>
					</div>
					<img class="del" @click="deleteFile(index)" src="https://ossfastmake.mustke.com/qrCode/tupian/1761120250640.svg" mode=""></img>
				</div>
			</div>
		</div>
		<input ref="fileInput" type="file" accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" style="display: none" @change="handleFileChange" />
	</div>
</template>

<script>
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
	export default {
		props: {
			params: {
				type: Object,
				default: {},
			},
			uuid: {
				type: String,
				default: "",
			},
		},
		data() {
			return {
				dataObj: {},
				index: 0,
				images: [],
				fileList: [],
			};
		},
		methods: {
			chooseFile() {
				this.$refs.fileInput.click();
			},
			handleFileChange(event) {
				const file = event.target.files[0];
				console.log(file, "选择的文件");
				const formData = new FormData();
				formData.append("file", file); // "file" 对应后端接收的字段名
				formData.append("uuid", this.uuid);
				this.$refs.fileInput.value = "";
				axios
					.post(baseURL + "/PCwj/file/uploads", formData, {
					headers: {
						"Content-Type": "multipart/form-data", // 必须设置
						token: localStorage.getItem("token"),
					},
					}).then((response) => {
						this.$message.success("上传成功！");
						this.fileList.push({
							name: file.name,
							url: response.data.urls,
							size: file.size
						});
						this.updateAnswer();
					}).catch((error) => {
						if (axios.isCancel(error)) {
							console.log("上传已取消:", error.message);
						} else {
							// this.$message.error("上传失败！");
						}
					});
			},
		 	updateAnswer() {
				console.log("kfeiwofifhi2o3f23irio23bfo2i3fb23oifb23", this.fileList);
				
				if (this.fileList.length) {
					const answerArr = this.fileList.map(file => {
						return {
							id: '',
							context: file.url,
							name: file.name
						}
					})
					this.dataObj.chooseList = JSON.stringify({
						list: this.fileList,
						value: this.fileList.map(f => f.url)
					})
					this.$emit('update', JSON.stringify({
						data: this.dataObj,
						index: this.index,
						answer: {
							question_id: this.dataObj.id,
							type: this.dataObj.type,
							answer: answerArr,
							if_hide: this.dataObj.if_hide
						}
					}))
				} else {
					this.dataObj.chooseList = JSON.stringify({list: [], value: []})
					this.$emit('update', JSON.stringify({
						data: this.dataObj,
						index: this.index,
						answer: {
							question_id: this.dataObj.id,
							type: this.dataObj.type,
							answer: [],
							if_hide: this.dataObj.if_hide
						}
					}))
				}
			},
			deleteFile(index) {
				this.$confirm("文件删除后不可恢复，确定删除吗？", "提示", {
					confirmButtonText: "确认删除",
					cancelButtonText: "取消",
					type: "warning",
				})
				.then(() => {
					console.log("111111111111");
					
					this.fileList.splice(index, 1);
					this.updateAnswer();
				})
				.catch(() => {
					console.log("222222222222");
				});
			}
		},
		watch: {
			params: {
				handler(newVal) {
					this.dataObj = newVal.data;
					this.index = newVal.index;
					this.images = JSON.parse(newVal.data.caseProblemImg || '[]');
					// this.fileList = JSON.parse(newVal.data.chooseList || '{"list":[]}').list;

					this.fileList = JSON.parse(newVal.data.chooseList || '{"list":[]}').list.map((item, idx) => {	
						return {
							name: item.name,
							url: item.context,
							size: item.size		
						}
					})
				},
				deep: true,
				immediate: true,
			},
		},
	};
</script>

<style scoped>
	.upload-file {
		margin: 10px 0;
	}

	.upload-file .button {
		background: #3a60ff;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 4px;
		font-size: 14px;
		color: #fff;
		font-weight: 600;
		margin-top: 10px;
		height: 39px;
		cursor: pointer;
	}

	.upload-file .button .icon {
		width: 17px;
		height: 17px;
	}

	.upload-file .text {
		font-size: 12px;
		color: #2b2f36;
		margin: 10px 0;
		text-align: center;
	}

	.upload-file .pictureNum {
		font-size: 13px;
		color: #4c4a56;
	}

	.file-list {
		margin-top: 10px;
	}

	.file-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.file-item .east {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		gap: 8.5px;
	}
	
	.file-item .icon {
		width: 24px;
		height: 21px;
		flex: none;
	}
		
	.file-item span {
		display: inline-block;
		vertical-align: middle;
		font-size: 14px;
		color: #333;
	}
		
	.file-item .del {
		width: 16px;
		height: 16px;
		cursor: pointer;
	}
		
	.file-item+.file-item {
		margin-top: 5px;
	}
</style>


// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewUploadFile.vue